import { render, staticRenderFns } from "./PsPatientMedicationDetail.vue?vue&type=template&id=5cddf854&"
import script from "./PsPatientMedicationDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientMedicationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports